import { createContext, useContext, useState, useEffect } from 'react';

const ActiveSessionContext = createContext();
export const ACTIVE_SESSION_STORAGE_KEY = 'currentActiveSession';
const LEGACY_SESSION_STORAGE_KEY = 'currentSession';

export const useActiveSession = () => useContext(ActiveSessionContext);

export const ActiveSessionProvider = ({ children }) => {
  const [activeSession, setActiveSession] = useState(null);

  // 🔁 Rehydrate on mount
  useEffect(() => {
    const saved =
      localStorage.getItem(ACTIVE_SESSION_STORAGE_KEY) ||
      localStorage.getItem(LEGACY_SESSION_STORAGE_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed?.startedAt) {
          setActiveSession(parsed);
          // Ensure old installs migrate to the canonical key.
          localStorage.setItem(ACTIVE_SESSION_STORAGE_KEY, JSON.stringify(parsed));
          localStorage.removeItem(LEGACY_SESSION_STORAGE_KEY);
          console.log('[ActiveSessionProvider] Rehydrated from localStorage:', parsed);
        }
      } catch (err) {
        console.warn('[ActiveSessionProvider] Failed to parse saved session:', err);
      }
    }
  }, []);

  // 💾 Save to localStorage whenever it changes
  useEffect(() => {
    if (activeSession) {
      localStorage.setItem(ACTIVE_SESSION_STORAGE_KEY, JSON.stringify(activeSession));
      localStorage.removeItem(LEGACY_SESSION_STORAGE_KEY);
    } else {
      localStorage.removeItem(ACTIVE_SESSION_STORAGE_KEY);
      localStorage.removeItem(LEGACY_SESSION_STORAGE_KEY);
    }
  }, [activeSession]);

  return (
    <ActiveSessionContext.Provider value={{ activeSession, setActiveSession }}>
      {children}
    </ActiveSessionContext.Provider>
  );
};
